import { LoadingButton } from '@mui/lab';
import { Alert, Box, CircularProgress, Stack } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useStore } from '../../../app/stores/store';
import RAMTableStation from './RAMTableStation';
import RAMTableSystem from './RAMTableSystem';

const RAMTable = () => {
	const { assetSetting, clearAssetSetting } = useStore().assetStore;
	const { selectedStation } = useStore().commonStore
	const { getStation, getSystem, loadingTable, downloadExcel, loadingDownload, clearList } = useStore().ramStore;

	const handleDownloadExcel = () => {
		if (selectedStation) {
			downloadExcel(selectedStation.id)
		}
	}
	
	useEffect(() => {
		clearList()
		clearAssetSetting()
	}, [clearList, selectedStation, clearAssetSetting])
  
	useEffect(() => {
		if (assetSetting.id) {
			switch (assetSetting.type) {
				case 'station':
				getStation(assetSetting?.id)
				break;
				case 'system':
				getSystem(assetSetting?.id)
				break;
			}
		}
	}, [getStation, assetSetting, getSystem])

	if (loadingTable) {
		return (
			<Stack justifyContent="center" direction="row">
				<CircularProgress />
			</Stack>
		)
	}
	
	return (
		<>
			{assetSetting.type 
			? (
				<>
					<Box sx={{display: 'flex', justifyContent: 'flex-end', mb: 2}}>
						<LoadingButton 
							onClick={handleDownloadExcel}
							variant='contained'
							loading={loadingDownload}
						>
							Download Excel
						</LoadingButton>
					</Box>
					{assetSetting.type === 'system' && <RAMTableSystem />}
					{assetSetting.type === 'station' && <RAMTableStation />}
					{assetSetting.type === 'equipment' && <Alert severity='info'>No table to display</Alert>}
				</>
			)
			: <Alert severity='info'>Please Select the Station or System</Alert>
			}
		</>
	);
}

export default observer(RAMTable)